// extracted by mini-css-extract-plugin
export var col1 = "page-head-section-module--col1--uJjpw";
export var col2 = "page-head-section-module--col2--AnAkO";
export var flex = "page-head-section-module--flex--jm7NY";
export var image = "page-head-section-module--image--ZycRz";
export var pageHead = "page-head-section-module--pageHead--YVDZU";